var labels = {
  titles: {
    nivel: 2,
    audience_images: {
      es: 'Imágenes generadas para audiencias',
      en: 'Audience Images'
    },
    audience_billing: {
      es: 'Facturación de Audiencias',
      en: 'Audience Billing'
    }
  },
  images_list: {
    nivel: 2,
    name: {
      es: 'Nombre',
      en: 'Name'
    },
    description: {
      es: 'Descripción',
      en: 'Description'
    },
    state: {
      es: 'Estado',
      en: 'State'
    },
    actions: {
      es: 'Acciones',
      en: 'Actions'
    },
    creation_user: {
      es: 'Usuario',
      en: 'User'
    },
    total: {
      es: 'Total Imágenes',
      en: 'Total Images'
    }
  },
  image_states: {
    nivel: 2,
    generated: {
      es: 'Generado',
      en: 'Created'
    },
    review: {
      es: 'En Revisión',
      en: 'Review'
    },
    approved: {
      es: 'Aprobado',
      en: 'Approved'
    },
    denied: {
      es: 'Rechazado',
      en: 'Denied'
    }
  },
  form_images: {
    nivel: 2,
    generate_image: {
      es: 'Crea tu imagen',
      en: 'Create your image'
    },
    generate_again: {
      es: 'Crea de nuevo',
      en: 'Create again'
    },
    download: {
      es: 'Descargar',
      en: 'Download'
    },
    view: {
      es: 'Ver',
      en: 'View'
    },
    delete: {
      es: 'Eliminar',
      en: 'Delete'
    },
    description: {
      es: 'Descripción Audiencia',
      en: 'Audience Description'
    },
    description_image: {
      es: 'Descripción Imagen',
      en: 'Image Description'
    },
    new_image: {
      es: 'Generador de Imágenes ChatGPT',
      en: 'ChatGPT Image Generator'
    },
    image_list: {
      es: 'Biblioteca',
      en: 'Library'
    },
    generative_image_title: {
      es: 'Imágenes generadas por IA',
      en: 'AI Generative Images'
    }
  },
  empresa: {
    es: 'Empresa',
    en: 'Company'
  },
  flag_approve_data: {
    es: '¿Puede aprobar solicitud de datos?',
    en: 'Approve data requests?'
  },
  flag_share_action: {
    es: '¿Puede compartir segmentos?',
    en: 'Share segments?'
  },
  flag_compose_fbk: {
    es: '¿Audiencias Facebook separadas?',
    en: 'Separated Facebook audiences?'
  },
  gpt_images: {
    es: '¿Puede generar Imágenes GPT?',
    en: 'Generate GPT Images'
  },
  edit_audience_type_google: {
    es: '¿Puede editar el tipo de audiencia en Google Ads?',
    en: 'Edit Audience Type in Google Ads?'
  },
  talonone_coupons: {
    es: '¿Tiene Cupones Talon One?',
    en: 'Talon One Coupons?'
  },
  retail_purchase_prediction: {
    es: '¿Puede ver Retail en Predicción de Compra?',
    en: 'Retail in Purchase prediction?'
  },
  actions: {
    es: 'Acciones',
    en: 'Actions'
  },
  segment_warning: {
    es: 'Se recomienda crear segmentos de al menos 300k para que sea eficiente en Google Ads y 600k en FB.',
    en: 'It is recommended to create segments of at least 300k to be efficient in Google Ads and 600k in FB.'
  },
  btns: {
    nivel: 2,
    init_billing: {
      es: 'Iniciar Facturación',
      en: 'Init Billing'
    }
  },
  form_cupones: {
    nivel: 2,
    usage_limit: {
      es: 'Límite de uso',
      en: 'Usage Limit'
    },
    discount_limit: {
      es: 'Límite de descuento',
      en: 'Discount Limit'
    },
    reservation_limit: {
      es: 'Límite de reserva',
      en: 'Reservation Limit'
    }
  },
  fecha_proceso: {
    es: 'Fecha Proceso',
    en: 'Proccess Date'
  }
};
export default labels;